import { render, staticRenderFns } from "./HomeUniversally.vue?vue&type=template&id=5250c946&scoped=true"
import script from "./HomeUniversally.vue?vue&type=script&lang=js"
export * from "./HomeUniversally.vue?vue&type=script&lang=js"
import style0 from "./HomeUniversally.vue?vue&type=style&index=0&id=5250c946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5250c946",
  null
  
)

export default component.exports